import React, { useState } from 'react';
import toast from 'react-hot-toast';
import api from '../../api';
import { Info } from  '../Info';


const createToken = ( {username, password, setToken} ) => {
  console.info(username, password);
  api.post(
    "/submit/token",
    {
      username: username,
      password: password,
    }, {
      headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    }
  ).then(response => {
      setToken(`Bearer ${response.data.access_token}`)
  })
}

export const RawFileUploader = ( {setToken} ) => {
  const [rawFile, setRawFile] = useState(null);
  const [datasetId, setDatasetId] = useState(null);
  const [password, setPassword] = useState(null);
  const [isUploaded, setIsUploaded] = useState(false);


  async function handleFileSubmit(event) {
    event.preventDefault();
    const fileForm = new FormData();
    fileForm.append('file', rawFile[0])

    const toastId = toast.loading('Submitting data..');
    console.log("submitted")
    await api.post(
      '/submit/dataset', fileForm, {headers: {"Content-Type": "multipart/form-data"}}
    ).then(response => {
      setPassword(response.data["password"]);
      setDatasetId(response.data["username"]);
      createToken({setToken: setToken, ...response.data});
      setIsUploaded(true);
      toast.success("Uploaded data", {id: toastId})
    }).catch(error => {
      try {
        const message = error.response.data.detail;
        toast.error(message, {id: toastId})
      } catch (error_) {
        toast.error("Something unexpected went wrong", {id: toastId})
      }
    });
  }

  function handleFileChange(event) {
    setRawFile(event.target.files);
    setIsUploaded(false);
  }
  return (
    <form onSubmit={handleFileSubmit}>
      <div className="mb-3 card card-body">
        <label htmlFor="rawFile" className="form-label">
          Raw file containing the lipid profile
        </label>
        <div className="input-group">
          <input type="file" className="form-control" id="rawFile" accept=".csv, .mztab, .ods, .xlsx" onChange={handleFileChange}/>
          <UploadButton isUploaded={isUploaded} file={rawFile}/>
        </div>
      </div>
      {((password !== null) & (datasetId !== null)) ? <Info datasetId={datasetId} password={password} /> : <></>}
    </form>
  )

}


function UploadButton( {isUploaded, file} ) {
  if (file == null) {
    return <button className="btn btn-primary" type='submit' disabled>Upload</button>
  } else if (isUploaded) {
    return <button type='submit' className="btn btn-success">Uploaded</button>
  }
  return <button className="btn btn-primary" type='submit'>Upload</button>
}
